"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TertiaryButton = exports.DangerTertiaryButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("./theme");
var _shared = require("./shared");
var _constants = require("../../utils/constants");
var _grid = require("../../../birch/layouts/grid");
var _reactUse = require("react-use");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultButtonProps = {
  disabled: false
};
var TertiaryButtonWrapper = _styledComponents["default"].button.withConfig({
  displayName: "tertiary_buttons__TertiaryButtonWrapper"
})(["padding:10px 0;text-decoration:underline;transition:none;background:none;border:none;&:active{box-shadow:none;}&:hover,&:focus{background:none;text-decoration:underline;border:none;}", " ", ""], _shared.CommonButtonStyles, function (_ref) {
  var theme = _ref.extensibleTheme;
  return "\n    color: ".concat(theme["default"].color, ";\n\n    &:hover,\n    &:focus {\n      color: ").concat(theme.hover.color, ";\n    }\n  ");
});
var ThemeableTertiaryButton = function ThemeableTertiaryButton(props) {
  var children = props.children,
    extensibleTheme = props.theme,
    disabled = props.disabled,
    onClick = props.onClick,
    className = props.className,
    icon = props.icon;
  var buttonRef = React.useRef(null);
  var isHovering = (0, _reactUse.useHoverDirty)(buttonRef);
  var styledIcon = icon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(icon, {
    color: isHovering ? extensibleTheme.hover.color : extensibleTheme["default"].color,
    size: 'xs'
  }));
  return /*#__PURE__*/React.createElement(TertiaryButtonWrapper, (0, _extends2["default"])({
    ref: buttonRef,
    extensibleTheme: extensibleTheme,
    disabled: disabled,
    "aria-disabled": props.disabled,
    onClick: onClick,
    className: className
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justifyContent: "center"
  }, icon && styledIcon, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true,
    title: children
  }, children)));
};
ThemeableTertiaryButton.defaultProps = defaultButtonProps;
var TertiaryButton = exports.TertiaryButton = function TertiaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableTertiaryButton, (0, _extends2["default"])({}, props, {
    theme: _theme.TertiaryButtonTheme
  }));
};
TertiaryButton.displayName = 'TertiaryButton';
TertiaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'tertiary-button'
});
var DangerTertiaryButton = exports.DangerTertiaryButton = function DangerTertiaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableTertiaryButton, (0, _extends2["default"])({}, props, {
    theme: _theme.DangerTertiaryButtonTheme
  }));
};
DangerTertiaryButton.displayName = 'DangerTertiaryButton';
DangerTertiaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'danger-tertiary-button'
});